import './index.css';
import { View, Text } from '../../../component';
import { TiDeleteOutline } from 'react-icons/ti';
import useTheme from '../../../utilities/hooks/theme';
// import { isDesktopBrowser } from '../../../utilities/helper';
import Modal from '@mui/material/Modal';
import { HiLightBulb } from 'react-icons/hi';
import React from 'react';
import { isSmartPhone } from '../../../utilities/helper';
import constants from '../../../constants';
import { useSelector } from 'react-redux';

interface Props {
  visible: boolean;
  onPressClose: any;
  insight: any;
  language: any;
}
const InsightInfo = ({ visible, onPressClose, insight, language }: Props) => {
  const { FantasyTheme: theme } = useTheme();
  const { themeType = '' } = useSelector((state: any) => state.setting);

  const insightData = language === 'en' ? insight?.english : insight?.hindi || '';
  const headerTitle = {
    color: '#fff'
  };
  const contentTitle = {
    color: '#fff'
  };
  return (
    <Modal open={visible} onClose={onPressClose}>
      <View
        style={{
          padding: isSmartPhone ? '20px 0px' : '',
          backgroundColor: isSmartPhone ? '#11171d' : '',
          background: !isSmartPhone ? theme.yesNoInsightModalBg : '#11171d',
          borderRadius: '10px',
          position: 'relative',
          border: isSmartPhone ? 'solid 1.5px #ffc400' : `1px solid ${theme.insightInfoBorder}`
        }}>
        <View>
          <View className={'insightInfo_header'}>
            {isSmartPhone ? (
              <HiLightBulb
                fill={isSmartPhone ? '#f6cf3f' : '#FE9900'}
                size={25}
                style={{
                  marginRight: 5
                }}
              />
            ) : (
              <img src={constants.Images.bulb} style={{ width: '20px', marginRight: '5px' }} />
            )}
            <Text style={headerTitle} className="insightInfo_headerTitle">
              {'Insight'}
            </Text>
          </View>
          <View className={isSmartPhone ? 'insightInfo__content' : 'insightInfo__content_web'}>
            <Text style={contentTitle} className="insightInfo__contentText">
              {insightData}
            </Text>
          </View>
        </View>
        <View
          onPress={onPressClose}
          className={isSmartPhone ? 'insightInfo__closeBtn' : 'insightInfo__closeBtn_web'}>
          {isSmartPhone ? (
            <TiDeleteOutline
              size={30}
              color={isSmartPhone ? '#ffc400' : theme.insightInfoCloseBtn}
            />
          ) : (
            <img
              src={themeType === 'dark' ? constants.Images.closeDark : constants.Images.close}
              width="20px"
            />
          )}
        </View>
      </View>
    </Modal>
  );
};
export default React.memo(InsightInfo);
